const EventsArray2021 = [
    {
        link: "https://files.iittp.ac.in/images/ProfKetterle-Talk.jpg",
        title: "IIT Tirupati and TCG-CQuERE MoU for research collaboration and doctoral program. Talk by Noble Laureate Prof. Ketterle",
        dt: "11-12",
        my: "Aug"
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Bioethanol_Symposium_Flyer2.pdf",
        title: "Two-Day Symposium on 'Challenges in the Production of 2G Bioethanol'",
        dt: "9-10",
        my: "Aug"
    },
    {
        link: "/pics/IIT T - Industry Academia Conclave Brochure.jpg",
        title: "Industry Academia Conclave- Manufacturing",
        dt: "20",
        my: "Nov"
    },
    {
        link: "#amp",
        title: "FDP - Advanced Manufacturing of Biomedical Devices for Precision Health Technologies",
        dt: "13-17",
        my: "Dec"
    },
    {
        link: "#fdp",
        title: "FDP - Novel Materials for Defense and Aerospace Applications",
        dt: "06-10",
        my: "Dec"
    },
    {
        link: "https://sites.google.com/view/spacetimedual/",
        title: "A Virtual Workshop on 'Spacetime duality in quantum circuits'",
        dt: "10-11",
        my: "Nov"
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Invitation_F4SAC.pdf",
        title: "Inauguration of Foundry 4.0 Student Activity Center",
        dt: "09",
        my: "Oct"
    },
    {
        link: "https://iittp.ac.in/institute-events",
        title: "2nd and 3rd (Joint) Convocation 2021",
        dt: "25",
        my: "Sep"
    },
    {
        link: "https://iittp.ac.in/camost/camostcs.php",
        title: "CAMOST's Colloquium Series, 16-20 August 2021",
        dt: "16-20",
        my: "Aug"
    },
    {
        link: "https://sites.google.com/view/pcpbconf",
        title: "Physical Chemistry Physical Biology (PCPB-2021) - Online Conference",
        dt: "24-28",
        my: "Sep"
    }
];

export default EventsArray2021;
